import { UseMutationOptions, useMutation, useQuery } from "@tanstack/react-query";
import { ApiServiceErr, axiosApi } from "../../../../api/apiService";
import { MAPPING_VERSION_QUERY_KEYS } from "../constants/mappingVersion.constants";
import { EditMappingPayload, EditMappingResult, NextVersionInfo } from "../types/mappingVersion.types";

export const useGetNextVersionInfo = (drawingToolId: string | undefined) =>
  useQuery<NextVersionInfo, ApiServiceErr>(
    [MAPPING_VERSION_QUERY_KEYS.nextVersionInfo, drawingToolId],
    async () => {
      const response = await axiosApi.get(`/mapping-versions/next-version/${drawingToolId}`);
      return response.data;
    },
    {
      enabled: !!drawingToolId
    }
  );

export const useEditMapping = (opt?: UseMutationOptions<EditMappingResult, ApiServiceErr, EditMappingPayload>) =>
  useMutation<EditMappingResult, ApiServiceErr, EditMappingPayload>(async payload => {
    const response = await axiosApi.post("/mapping-versions/edit-mapping", payload);
    return response.data;
  }, opt);
